/* eslint-disable react/no-danger */
import React from 'react';
import { connect } from 'react-redux';
import styles from './advisories/advisories.module.scss';

const MaintenanceResponsibility = ({
  maintenance_responsibility
}) => (
  <div className={styles.advisories}>
    <header>Maintenance Responsibility</header>
    <div className={styles.list}>
      <div className={styles.head}>
        <div className={styles.Airportcontent} style={{ overflow: 'auto', height: '200px', padding: '20px' }}>
          <div className={styles.RTE} dangerouslySetInnerHTML={{ __html: maintenance_responsibility }} />
        </div>
      </div>
    </div>
  </div>
);

const mapStateToProps = () => ({

});


const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceResponsibility);
